import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useAppNavigate from "../../components/router/use-app-navigate";
import AuthContext from "../../components/auth-context";
import Form from "../../components/inputs/form";
import Textbox from "../../components/inputs/textbox";
import Submit from "../../components/inputs/submit";
import { useLocation } from "react-router-dom";
import ShopLayout from "../../components/signup/shop-layout";
import ShopCustomerApi from "../../api/shop-customer";
import ShopProductApi from "../../api/shop-product";

interface RequestForm {
  cellPhone?: string;
}

interface ICellPhoneForm {
  type?: number;
  tariffId?: number;
  ngnNumber?: string;
  shippingId?: number;
  modemId?: number;
  tags?: string;
}

function CellPhoneForm(props: ICellPhoneForm) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RequestForm>();

  const [errorMessage, setErrorMessage] = useState("");
  const [isShopPendingCustomer, setisShopPendingCustomer] = useState(false);
  const navigate = useAppNavigate();
  const { t } = useTranslation(undefined, { keyPrefix: "Shop" });
  const context = useContext(AuthContext);
  const location = useLocation();
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const state = location.state || {};
  const type = props.type ?? state.type;
  const tariffId = props.tariffId ?? state.tariffId;
  const shippingId = props.shippingId ?? state.shippingId;
  const ngnNumber = props.ngnNumber ?? state.ngnNumber;
  const tags = props.tags ?? state.tags;
  const optionalProducts = state.optionalProducts as number[] | undefined;

  useEffect(() => {
    console.log("type:", type);
    console.log("tariffId:", tariffId);
    console.log("ngnNumber:", ngnNumber);
    console.log("optionalProducts:", optionalProducts);
    console.log("shippingId:", shippingId);
    console.log("tags", tags);
  }, [type, tariffId, ngnNumber, optionalProducts, shippingId, tags]);

  const onSubmit = async (data: RequestForm): Promise<string> => {
    try {
      console.log("Submitting phone:", data.cellPhone);
      setIsSubmit(true);
      let validationSimCardCount = await new ShopProductApi(context).get(
        data.cellPhone!,
      );

      if (validationSimCardCount.errorMessage != null) {
        setErrorMessage(validationSimCardCount.errorMessage);
        return validationSimCardCount.errorMessage;
      }

      let res = await new ShopCustomerApi().post(data.cellPhone!);
      if (!res.errorMessage) {
        context.setCustomerInfo?.(data);
        setisShopPendingCustomer(res?.isShopPendingCustomer);
        setIsSubmit(false);
        const updatedOptionalProducts = [...(optionalProducts || [])];
        if (props.modemId && !updatedOptionalProducts.includes(props.modemId)) {
          updatedOptionalProducts.push(props.modemId);
        }

        navigate("/shop/verifyNumber", {
          state: {
            type,
            tariffId,
            cellPhone: data.cellPhone,
            ngnNumber,
            optionalProducts: updatedOptionalProducts,
            shippingId,
            isShopPendingCustomer: res.isShopPendingCustomer,
            tags,
          },
        });

        return "success";
      } else {
        console.log("Error:", res.errorMessage);
        setErrorMessage(res.errorMessage);
        return res.errorMessage;
      }
    } catch (error) {
      console.error("Submission exception:", error);
      const fallbackMessage =
        t("UnexpectedError") || "خطایی در ارسال فرم رخ داده است.";
      setErrorMessage(fallbackMessage);
      return fallbackMessage;
    }
  };

  if (!type || !tariffId) {
    return (
      <div className="p-5 text-center text-red-600 font-bold">
        اطلاعات خرید ناقص است. لطفاً از مسیر فروشگاه اقدام کنید.
      </div>
    );
  }

  return (
    <ShopLayout
      step={type === 40 ? 3 : 2}
      type={type}
      steps={type === 40 ? [2, 3, 4] : [1, 2, 3]}
    >
      <div className="pt-10">
        <Form
          submit={onSubmit}
          handleSubmit={handleSubmit}
          className="xs:w-full md:w-2/4 xl:w-2/6 mx-auto xs:p-0 mt-10 p-10 rounded-xl"
        >
          <div className="flex flex-col space-y-6">
            <h3 className="lead-title pt-2 pb-2">{t("Title")}</h3>

            <Textbox
              {...register("cellPhone", {
                required: t("RequiredMessage"),
                pattern: {
                  value: /^09\d{9}$/,
                  message: t("InvalidPhone"),
                },
              })}
              label={t("CellPhoneLabel")}
            />

            {errors.cellPhone && (
              <p className="text-red-500 text-sm">{errors.cellPhone.message}</p>
            )}

            {errorMessage && (
              <p className="text-red-500 text-sm">{errorMessage}</p>
            )}

            <Submit loading={isSubmit} />
          </div>
        </Form>
      </div>
    </ShopLayout>
  );
}

export default CellPhoneForm;
